import React from 'react';

// The branded frame every invitation surface renders inside. Deliberately does
// NOT mount anything from the authenticated app shell: these routes are public
// and must not trigger the sign-in bootstrap that calls ensureUserAccount,
// which would provision a default-tier workspace ahead of acceptance. Purely
// presentational — props in, markup out, no data fetching, no auth calls.
export default function InvitationShell({ children }) {
    return (
        <div className="min-h-screen bg-[color:var(--color-light)] flex flex-col items-center px-4 py-10">
            <img
                src="/images/keyflow-logo.generated.svg"
                alt="KeyFlow"
                width="40"
                height="40"
                className="h-10 w-10 mb-6"
            />
            <div className="w-full max-w-lg bg-[color:var(--surface-primary)] border border-[color:var(--border-color)] rounded-[length:var(--radius-card)] p-8">
                {children}
            </div>
            <div className="mt-8 text-xs text-[color:var(--text-muted)]">
                <a href="/terms" className="underline hover:opacity-80">Terms of Service</a>
                <span className="mx-2">|</span>
                <a href="/privacy" className="underline hover:opacity-80">Privacy Policy</a>
            </div>
        </div>
    );
}
